<template>
  <div id="footer">
    <div id="blue-footer">
      <img src="@/assets/logos/logo_T-white.svg" alt="Texas Rangers" />
    </div>
    <div id="black-footer">
      <b-container>
        <div class="legal-text">
          <p>&copy; 2021 MLB Advanced Media, LP. All rights reserved.</p>
          <p>Other restrictions may apply.</p>
        </div>
        <img src="@/assets/icons/ranger-dot-com.svg" alt="texasrangers.com" />
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
#footer {
  width: 100%;

  #blue-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    width: 100%;
    background-color: $rangers-blue;
    color: #fff;
    img {
      padding: 27px 0;
    }
  }
  #black-footer {
    width: 100%;
    background-color: $dark-blue;
    height: 40px;
    @media only screen and (max-width: $sm) {
      height: 69px;
      img {
        margin-top: 11px;
      }
    }
    .container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      @media only screen and (max-width: $sm) {
        flex-direction: column-reverse;
      }
      .legal-text {
        text-align: left;
        @media only screen and (max-width: $sm) {
          text-align: center;
          padding-bottom: 5px;
        }
        p {
          margin: auto 0;
        }
      }
      img {
        height: 13px;
      }
    }
  }
}
</style>
